module.exports = __webpack_public_path__ + "media/Goldberg_Variations_01_Aria.a56eeddc.mp3";